/** @jsx h */
import { h } from 'preact'

import t from '../../../utils/translate'

const ProductSummary = ({ name, avatarUrl }) => (
  <section class='ModalCard-section'>
    <h3 class='ModalCard-heading'>
      {t('proof_points.js.product.associated')}
    </h3>
    <div class='ModalCardHeader ModalCardHeader--organization'>
      {avatarUrl &&
        <div class='ModalCardHeader-logo ModalCardHeader-logo--product'>
          <img src={avatarUrl} alt='' width='80' height='80' />
        </div>}
      <div class='ModalCardHeader-details'>
        <h2 class='ModalCardHeader-title'>{name}</h2>
      </div>
    </div>
  </section>
)

export default ProductSummary
